import Constants from '../../Constants';
import VirtualDomElement from '../VirtualDomElement';
import TextElement from './TextElement';

export default class Label extends VirtualDomElement {
  textElement: TextElement;
  maxWidth: any;

  constructor(x, y, label, fontSize, maxWidth, onRequestDraw) {
    super(onRequestDraw);

    this.maxWidth = maxWidth;
    this.textElement = new TextElement({
      text: label,
      fontSize: fontSize,
      x: x,
      y: y,
    });
    this.set('x', x);
    this.set('y', y);
    this.set('fontSize', fontSize);
    this.set('text', label);
  }

  draw(ctx, transform) {
    ctx.textAlign = 'center';

    ctx.fillStyle = '#ffffff';
    ctx.shadowBlur = Constants.subTopics.shadowBlur * transform.k;
    ctx.shadowColor = `rgba(121,125,119,1`;

    ctx.font = `${this.textElement.get('fontSize') * transform.k}px ${Constants.general.fontFamily}`;
    let [xText, yText] = transform.apply([
      this.textElement.get('x'),
      this.textElement.get('y'),
    ]);
    [xText, yText] = this.getFlooredCoordinates([xText, yText]);

    const textHeight = this.textElement.get('fontSize') * transform.k;
    const textWidth = this.maxWidth * transform.k;
    ctx.fillRect(
      xText,
      yText - textHeight * 1.25,
      textWidth * 1,
      textHeight * 1.7,
    );
    ctx.fillStyle = '#555';
    ctx.shadowBlur = 0;
    ctx.fillText(
      this.get('text'),
      xText + textWidth / 2,
      yText,
      textWidth * 0.9,
    );
  }
}
